$(document).ready(function () {
    $('body').on('click', '.get-route-with-confirmation', function (evt) {
        evt.preventDefault();

        let confirmMessage = $(this).data('confirm_message');
        let actionRoute = $(this).data('action_route');
        Swal.fire({
            text: confirmMessage,
            icon: "warning",
            buttonsStyling: false,
            showCancelButton: true,
            cancelButtonText: _t('Cancel'),
            cancelButtonClass: "btn btn-default",
            confirmButtonText: _t('Yes'),
            confirmButtonClass: "btn btn-success",
        })
            .then(function (result) {
                if(result.value) {
                    window.location = actionRoute;
                }
            });
    })
});


// WEBPACK FOOTER //
// ./resources/js/app/_global.js